import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_stand-out-branding/artifacts/j1kstteb_PHOTO-2026-05-18-20-50-29.jpg";

/**
 * Real Little Things Studio logo (tree-with-roots + wordmark).
 * The source file is the stacked colour mark on white.
 * `variant`:  "nav"   → compact, just the symbol area cropped tightly
 *             "stacked" → full mark with tag (for footer / large placements)
 */
const LTLogo = ({ variant = "nav", height = 44, dataTestid = "lt-logo" }) => {
  const tall = variant === "stacked";
  return (
    <a
      href="#top"
      data-testid={dataTestid}
      className="inline-flex items-center group select-none"
      aria-label="Little Things Studio — Home"
      style={{ lineHeight: 0 }}
    >
      <img
        src={LOGO_URL}
        alt="Little Things Studio"
        style={{
          height: tall ? height * 2.6 : height,
          width: "auto",
          mixBlendMode: "multiply",
          objectFit: "contain",
        }}
        draggable={false}
      />
    </a>
  );
};

export default LTLogo;
